package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class ListingLayoutsEnum {
    LIST,
    TILES;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            LIST -> strings.list
            TILES -> strings.tiles
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                LIST -> strings.list
                TILES -> strings.tiles
            }
        }
}